<template>
    <div class="all">
        <!-- 预警信息列表 -->
        <div class="warp h-auto">
            <div class="warp-body">
                <h2 class="title">我的联系人</h2>
                <div class="firle mt20 clearfix">
                    <div class="corm fl clearfix">
                        <span class="element cp" :class="tabType === 'wx' ? 'curr' : ''" @click="yujinAcceptList('wx');">微信</span>
                        <span class="element cp" :class="tabType === 'tel' ? 'curr' : ''" @click="yujinAcceptList('tel');">短信</span>
                        <span class="element cp" :class="tabType === 'email' ? 'curr' : ''" @click="yujinAcceptList('email');">邮箱</span>
                    </div>
                    <div class="corm fr clearfix">
                        <button class="btn btn-jbblue" v-if="tabType === 'wx' && $parent.company.config.openAddWeContact === 1" @click="openWxReceiver();"><i class="icons add-icon"></i>添加微信接收人</button>
                        <button class="btn btn-jbblue" v-if="tabType === 'tel'" @click="openTelReceiver();"><i class="icons add-icon"></i>添加短信接收人</button>
                        <button class="btn btn-jbblue" v-if="tabType === 'email' && $parent.company.config.openAddEmailContact === 1" @click="openTelReceiver();"><i class="icons add-icon"></i>添加邮箱接收人</button>
                    </div>
                </div>
                <table class="table mt20 border" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="30%">
                        <col width="30%">
                        <col width="10%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th v-if="tabType === 'wx'">头像</th>
                            <th v-if="tabType === 'wx'">微信昵称</th>
                            <th v-if="tabType !== 'wx'">姓名</th>
                            <th v-if="tabType === 'tel'">手机号码</th>
                            <th v-if="tabType === 'email'">邮箱</th>
                            <th class="ar">操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in list" :key="index">
                            <td v-if="tabType === 'wx'"><img :src="item.value == '' ? '/static/images/no_img.jpg' : item.value" alt="" width="50" height="50"></td>
                            <td>{{item.username}}</td>
                            <td v-if="tabType !== 'wx'">{{item.value}}</td>
                            <td class="ar">
                                <div class="table-all-icons move-bian">
                                    <a title="修改" href="javascript:void(0);" @click="editContacts(index);" class="icons edit-icon1"></a>
                                    <a title="删除" href="javascript:void(0);" @click="delContacts(item.id);" class="icons del-sm-icon"></a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
            </div>
        </div>
        <!-- 添加微信接收人 -->
        <Dialog ref="wxModal" title="添加微信接收人" type="normal" width=380 :modalFoot="false">
            <div slot="mdBox">
                <img class="wxEwm db" :src="wxUrl" />
                <h3 v-if="!peopleFull" class="color-red ac">联系人添加已达上限</h3>
            </div>
        </Dialog>
        <!-- 添加短信 -->
        <Dialog ref="telModal" :title="modalTitle" :callback="saveTelReceiver" :callbackDel="initData" type="normal" width=380 :iscall="true">
            <div slot="mdBox">
                <div class="form-warp">
                    <div class="item">
                        <input v-if="tabType === 'wx'" class="input-text" v-model.trim="name" maxlength="10" type="text" placeholder="请输入微信昵称"/>
                        <input v-else class="input-text" v-model.trim="name" maxlength="10" type="text" placeholder="请输入接收人姓名"/>
                    </div>
                    <div class="item" v-if="tabType === 'tel'">
                        <input class="input-text" v-model="phone" maxlength="11" type="text" placeholder="请输入接收人手机号码"/>
                    </div>
                    <div class="item" v-if="tabType === 'email'">
                        <input class="input-text" v-model="email" maxlength="50" type="text" placeholder="请输入接收人邮箱"/>
                    </div>
                </div>
            </div>
        </Dialog>
        <!-- 删除提示 -->
        <Dialog ref="delModal" :callback="enterDel" type="confirm">
            <div slot="mdBox">
                <p class="ac">确定删除联系人</p>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
export default {
    components:{Dialog},
    data() {
        return {
            planId:'',//方案ID
            tabType:'wx',//微信、短信、邮箱类型
            delId:'',//当前删除的ID
            name:'',//姓名
            phone:'',//手机号码
            email:'',//邮箱
            timeer:'',
            editId:'',//编辑ID
            modalTitle:'',
            nodata:false,//暂无数据
            list:[],
            peopleFull:true,//后台返回人员已满
            wxUrl:''//微信二维码地址
        }
    },
    mounted() {
        let that = this;
		that.$nextTick(()=> {
            that.yujinAcceptList('wx');//预警接收设置预加载
        })
    },
    beforeDestroy() {
        clearInterval(this.timeer);
    },
    created() {
		// 获取缓存方案数据
        this.planId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        //初始化信息
        initData(){
            this.name='';//姓名
            this.phone='';//手机号码
            this.email='';//邮箱
        },
        // 联系人列表
        yujinAcceptList (type) {
            let that = this;
            that.tabType = type;
            clearInterval(that.timeer);
            that.list = [];
            that.$parent.loadModal(true,'正在请求数据...');
            that.$api.get('user/contact/list', {type:type}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.list = r.data;
                    if(r.data.length <= 0){//没有数据
                        that.nodata = true;
                    }else{
                        that.nodata = false;
                    }
                })
            })
            // if(type === 'wx'){//微信时5秒请求一次数据
            //     that.timeer = setInterval(() => {
            //         that.$api.get('user/contact/list', {type:type}, r => {
            //             that.$parent.returnCode(r,function(){
            //                 that.list = r.data;
            //                 if(r.data.length <= 0){//没有数据
            //                     that.nodata = true;
            //                 }else{
            //                     that.nodata = false;
            //                 }
            //             })
            //         })
            //     }, 5000);
            // }
        },
        // 添加微信接收人
        openWxReceiver () {
            let that = this;
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('user/contact/wx-img', null, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    if(!r.data.status){
                        that.$utils.alertText('联系人已达上限！');
                    }else{
                        that.wxUrl = r.data.url;
                        that.$refs.wxModal.showMaskFun(); 
                        that.timeer = setInterval(() => {
                            that.$api.get('user/contact/list', {type:'wx'}, r => {
                                that.$utils.returnCode(r,function(){
                                    that.peopleFull = r.msg;
                                    if(that.tabType === r.data[0].type){
                                        that.list = r.data;
                                    } 
                                    if(that.$refs.wxModal.showMask == false || r.msg == false){
                                        clearInterval(that.timeer);
                                    }
                                    if(r.data.length <= 0){//没有数据
                                        that.nodata = true;
                                    }else{
                                        that.nodata = false;
                                    }
                                })
                            })
                        }, 1000);
                    }  
                })
            })
        },
        // 添加短信接收人
        openTelReceiver () {
            let that = this;
            if(that.tabType === 'tel'){
                that.modalTitle = '添加短信接收人';
            }else if(that.tabType === 'email'){
                that.modalTitle = '添加邮箱接收人';
            }
            that.$refs.telModal.showMaskFun(); 
        },
        // 保存短信接收人
        saveTelReceiver () {
            let that = this;
            let name = that.name;
            let phone = that.phone;
            let email = that.email;
            let id = that.editId;
            if(name == ''){
                that.$utils.alertText('请输入接收人姓名');
                return;
            }else if(phone == '' && that.tabType === 'tel'){
                that.$utils.alertText('请输入接收人手机号码');
                return;
            }else if(!(/^1\d{10}$/.test(phone)) && that.tabType === 'tel'){
                that.$utils.alertText('请输入正确的接收人手机号码');
                return;
            }else if(email == '' && that.tabType === 'email'){
                that.$utils.alertText('请输入接收人邮箱');
                return;
            }else if(!(/^[\w!#$%&'*+\/=?^_`{|}~-]+(?:\.[\w!#$%&'*+\/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/.test(email)) && that.tabType === 'email'){
                that.$utils.alertText('请输入正确的接收人邮箱');
                return;
            }
            let datas = '';
            let url = '';
            if(that.tabType === 'tel'){
                url = 'user/contact/tel-create';
                datas = {
                    id:id,
                    username:name,
                    tel:phone
                }
            }else if(that.tabType === 'email'){
                url = 'user/contact/email-create';
                datas = {
                    id:id,
                    username:name,
                    email:email
                }
            }else{
                url = 'user/contact/change-wx-name';
                datas = {
                    contactId:id,
                    username:name
                }
            }
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post(url, {data:datas}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$refs.telModal.closeMask();
                    that.list = r.data; 
                    that.editId = '';
                    that.name = '';
                    that.email = '';
                    that.phone = '';
                    if(r.data.length <= 0){//没有数据
                        that.nodata = true;
                    }else{
                        that.nodata = false;
                    } 
                    that.$utils.alertText('保存成功'); 
                })
            })
        },
        // 修改联系人
        editContacts (index) {
            let that = this;
            let id = that.list[index].id;
            that.editId = id;
            that.name = that.list[index].username;
            if(that.tabType === 'tel'){
                that.phone =  that.list[index].value;
            }else if(that.tabType === 'email'){
                that.email =  that.list[index].value;
            }
            that.$refs.telModal.showMaskFun();
        },
        // 删除联系人
        delContacts (id) {
            let that = this;
            that.delId = id;
            that.$refs.delModal.showMaskFun();
        },
        // 确认删除
        enterDel () {
            let that = this;
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.get('user/contact/delete', {type:that.tabType,contactId:that.delId}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$refs.delModal.closeMask();
                    that.list = r.data;
                    if(r.data.length <= 0){//没有数据
                        that.nodata = true;
                    }
                    that.$utils.alertText('删除成功');   
                })
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/receiveSet.vue